/* hero-video-audio.js (repurposed for skate video panel)
   Story 16 — unmute skate video when >=50% in viewport; mute when out.
*/
(function () {
  'use strict';

  var video = document.querySelector('.skate-video__video');
  if (!video) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio >= 0.5) {
        video.muted = false;
        if (video.paused) {
          video.play().catch(function () { video.muted = true; });
        }
      } else {
        video.muted = true;
      }
    });
  }, { threshold: [0, 0.5] });

  observer.observe(video);
})();
